import { cn } from '../../lib/utils';

/**
 * FormLabel component matching design system specifications
 * Standardized label component with support for different alignment and spacing variants
 * 
 * All labels use text-meta (12px) to comply with typography constraint.
 * 
 * @param {string} align - Alignment: 'left' (default) or 'right'
 * @param {string} width - Width class (e.g., 'w-32' for right-aligned labels)
 * @param {boolean} required - Show required indicator
 * @param {boolean} spacing - Add bottom margin (mb-1)
 */
export const FormLabel = ({ 
  children, 
  htmlFor, 
  align = 'left', 
  width, 
  required = false, 
  spacing = true,
  className,
  ...props 
}) => {
  const labelClasses = cn(
    'text-xs font-medium text-gray-700 dark:text-gray-300', // 12px - complies with typography constraint
    {
      'block': align === 'left' || spacing,
      'text-right': align === 'right',
      'whitespace-nowrap': align === 'right',
      'mb-1': spacing,
      [width || '']: width && align === 'right',
    },
    className
  );

  return (
    <label 
      htmlFor={htmlFor}
      className={labelClasses}
      {...props}
    >
      {children}
      {required && (
        <span className="text-[var(--ds-status-danger)] ml-1">*</span>
      )}
    </label>
  );
};

FormLabel.displayName = 'FormLabel';
